// extracted by mini-css-extract-plugin
module.exports = {"styledLink":"link_styledLink__XOeoG","focus-visible":"link_focus-visible__4uMnU","primaryLight":"link_primaryLight__M2AtN","primary":"link_primary__acNsy"};